module.exports = __webpack_public_path__ + "img/about-辅导项目-中级职称（医学技术）类.54fee536.jpg";